/**
 * Single source of truth für die Reifenwechsel-Preismatrix.
 * Genutzt auf /reifenwechsel UND auf /dienstleistungen.
 *
 * - base:   Basispreis für 4 Räder (eigene/gebrauchte Reifen)
 * - surNew: Aufpreis pro Rad bei fabrikneu mitgebrachten Reifen (× 4 Räder)
 */
export type ReifenwechselPrice = {
  size: string;
  base: number;
  surNew: 10 | 20;
};

export const REIFENWECHSEL_PRICES: ReifenwechselPrice[] = [
  { size: 'Bis 16"', base: 90, surNew: 10 },
  { size: '17/18"', base: 110, surNew: 10 },
  { size: '19"', base: 120, surNew: 10 },
  { size: '20"', base: 120, surNew: 20 },
  { size: '21"', base: 140, surNew: 20 },
  { size: 'Ab 22"', base: 160, surNew: 20 },
];

export const totalWithNewTires = (p: ReifenwechselPrice) => p.base + 4 * p.surNew;